import { useQuery } from '@tanstack/react-query';
import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import { lazy, Suspense } from 'react';

import { getSignin } from 'services/idm';

import { apiErrorHandler } from '@login/helpers';
import { useApiRedirect } from '@login/hooks/useApiRedirect';

const SigninForm = lazy(
	() => import('@login/patterns/signin-form/signin-form')
);
const FormBox = lazy(() => import('@login/components/form-box/form-box'));

type PageProps = {
	locale?: string;
};

export const getStaticProps = (async (params) => {
	const locale = params?.locale as string;

	return { props: { locale } };
}) satisfies GetStaticProps<PageProps>;

const SignIn = ({ locale }: InferGetStaticPropsType<typeof getStaticProps>) => {
	const { goToRedirect } = useApiRedirect();

	const { data: signinData } = useQuery({
		throwOnError: true,
		queryKey: ['signin', locale],
		queryFn: () =>
			getSignin(locale).catch((error) => {
				apiErrorHandler(error, locale);
				return null;
			}),
	});

	if (signinData)
		goToRedirect({
			action: signinData.action,
			url: signinData.redirectUrl,
			isConnect: true,
		});

	if (signinData && signinData.action === 'Display') {
		return (
			<Suspense>
				<FormBox>
					<SigninForm
						placeholders={signinData.placeholders}
						token={signinData?.xsrfToken}
						userUnderAge={
							signinData.action === 'Display' &&
							signinData.flow.contentId === 'user-under-age'
						}
					/>
				</FormBox>
			</Suspense>
		);
	}

	return null;
};

export default SignIn;
